export const GET_GLOBAL_NOTIFICATIONS_SUCCESS = "GET_GLOBAL_NOTIFICATIONS_SUCCESS";
export const DISABLE_GLOBAL_NOTIFICATION_SUCCESS = "DISABLE_GLOBAL_NOTIFICATION_SUCCESS";
export const ENABLE_GLOBAL_NOTIFICATION_SUCCESS = "ENABLE_GLOBAL_NOTIFICATION_SUCCESS";
